// extracted by mini-css-extract-plugin
export default {"centered":"LoginPage_centered__iB4eU","loginForm":"LoginPage_loginForm__G08Gb"};